<!--
 * @Author: yaoyuting
 * @Date: 2020-03-20 19:30:58
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-06 09:00:19
 * @Descripttion:
-->
<template>
  <div :class="currentRouteClass">
    <div :class="currentRouteClass1">
      <div class="footer-Top" id="one">
        <p>You can get the latest events information from transformers.</p>
        <p>
          <el-form
            :model="ruleForm"
            :rules="rules"
            prop="email"
            ref="ruleForm"
            class="demo-dynamic"
            autocomplete="off"
          >
            <el-form-item prop="email">
              <el-input v-model="ruleForm.email" placeholder="Enter your email">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm(ruleForm.email)"
                >Subscribe now</el-button
              >
            </el-form-item>
          </el-form>
        </p>
        <ul>
          <li>
            <p class="p1">Developer</p>
            <router-link to="/Index/StartBuilding" class="ap">
              <p>Start building</p>
            </router-link>

            <p>
              <a :href="`${baseUrl}/doc/structure/`" target="_blank"
                >Transformers architecture
              </a>
            </p>

            <p>
              <a :href="`${baseUrl}/doc/developer`" target="_blank"
                >Develop documentation</a
              >
            </p>
            <p>
              <a
                :href="`${baseUrl}/doc/developer/set`"
                target="_blank"
                >API documentation</a
              >
            </p>
            <p>
              <a
                :href="`${baseUrl}/doc/run-node`"
                target="_blank"
                >Deploy application</a
              >
            </p>
          </li>
          <li>
            <p>Learning</p>
            <router-link to="/Index/Overview" class="ap">
              <p>Transformers overview</p>
            </router-link>
            <!-- <router-link to="/pc/Wallet" class="ap">
              <p>Transformers wallet</p>
            </router-link> -->
            <p>
              <a href="https://explorer.tfsc.io/" target="_blank"
                >Transformers testnet Explorer</a
              >
            </p>
            <p>
              <a
                :href="`${baseUrl}/doc/ecology/overview`"
                target="_blank"
                >Ecosystem economic overview</a
              >
            </p>
            <p>
              <a :href="`${baseUrl}/doc/ecology/expenditure#stake`" target="_blank"
                >Stake TTOS
              </a>
            </p>
            <p>
              <a
                :href="`${baseUrl}/doc/ecology/revenue`"
                target="_blank"
              >
                Obtain revenue
              </a>
            </p>
            <p>
              <a
                :href="`${baseUrl}/doc/ecology/inflation`"
                target="_blank"
              >
                Financial instrument
              </a>
            </p>
          </li>
          <li>
            <p>Technology</p>
            <p>
              <a :href="`${baseUrl}/doc/intro`" target="_blank"
                >Preliminary understanding of Transformers</a
              >
            </p>
            <p>
              <a :href="`${baseUrl}/doc/`" target="_blank"
                >Technology wiki</a
              >
            </p>
            <p>
              <a href="https://github.com/tfs-labs" target="_blank"
                >Open-source code</a
              >
            </p>
            <!-- <p>Technology roadmap</p> -->
            <router-link to="/Index/Ecological" class="ap">
              <p>Ecosphere</p>
            </router-link>
          </li>
          <li>
            <p>Community</p>
            <!-- <router-link to="/pc/Email" class="ap"> -->
            <p>Subscribe campaign email</p>
            <!-- </router-link> -->
            <!-- <router-link to="/Index/Ranking" class="ap">
              <p>Community Invitation</p>
            </router-link> -->
            <!-- <router-link to="/pc/Group" class="ap">
              <p>Join Transformers group</p>
            </router-link>
            <a
              href="https://www.tfsc.io/test-tfscbrowser-periodone"
              target="_blank"
              class="ap"
            >
              <p>Beta test data query</p>
            </a> -->
            <router-link to="/Index/Ambassador" class="ap">
              <p>Ambassador Program</p>
            </router-link>
            <router-link to="/Index/Brand" class="ap">
              <p>Brand Kit</p>
            </router-link>
            <!-- <router-link to="/pc/Group" class="ap"> -->
            <!-- <p><a href="#">Beta test data query</a></p> -->
            <!-- </router-link> -->
          </li>
          <li>
            <p>Strategic cooperation</p>

            <router-link to="/Index/Application" class="ap">
              <p>Investment application</p>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="footer-BOttom">
        <!-- <p>
          <span>Contact Us</span><br />
          <span>transformerschain@outlook.com</span><br />
          <span
            >Having trouble using the product? Try asking the<br />
            support team for answers</span
          >
        </p> -->
        <p>
          <span>Follow us</span>
          <span>
            <a href="https://medium.com/@transformerschain" target="_blank">
              <img src="../../assets/pc/Home/Home20.png"
            /></a>
            <a href="https://twitter.com/TFSCChain" target="_blank"
              ><img src="../../assets/pc/Home/Home18.png"
            /></a>
            <a href="https://t.me/transformerschain" target="_blank"
              ><img src="../../assets/pc/Home/Home19.png"
            /></a>
            <!-- <a href="https://discord.gg/tfscchain001"
              > -->
            <a href="https://discord.com/invite/W4YsQduNrf" target="_blank">
              <img src="../../assets/pc/Home/Home16.png"
            /></a>
            <a
              href="https://www.youtube.com/channel/UCxkH0sBwC9cASd3c3qwyvmA"
              target="_blank"
              ><img src="../../assets/pc/Home/Home17.png"
            /></a>
            <a href="https://github.com/tfs-labs" target="_blank">
              <img src="../../assets/pc/Home/git.png"
            /></a> </span
          ><br />
          <!-- <span>transformerschain@outlook.com</span><br />
          <span style="display: block; margin-top: 20px">
            {{ $t("footer.Tranformers") }}
          </span> -->
        </p>
        <div class="footerby">
          <!-- <span>transformersChain@tfsc.io</span> -->
          <!-- <span>
            {{ $t("footer.Tranformers") }}
          </span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { base2 } from "@/assets/server/api";
import { GetEmail } from "@/assets/server/api.js";
export default {
  data() {
    return {
      baseUrl: base2,
      ruleForm: { email: "" },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            // message: "Please input email",
            trigger: "blur",
          },
        ],
      },
      W: document.body.clientWidth + "px",
    };
  },
  created() {
    // this.$bus.$emit("goAuchor", "#one");
  },
  computed: {
    currentRouteClass() {
      return this.$route.path === "/Index/MintNFT" ? "mintfoot" : "foot";
    },
    currentRouteClass1() {
      return this.$route.path === "/Index/MintNFT" ? "mintfoot-W" : "footer-W";
    },
  
  },
  methods: {
    Push(index) {},
    async submitForm(formName) {
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (formName != "") {
        if (formName != "" && !regEmail.test(formName)) {
          this.$message({
            message: "Email must be formatted correctly",
            type: "error",
          });
          this.ruleForm.email = "";
        } else {
          let formData = new FormData();
          let params = {
            email: this.ruleForm.email,
          };
          console.log("params", params);
          let item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          console.log(formData);
          let data = await GetEmail(formData);
          this.$message({
            showClose: true,
            message: "Mailbox subscription succeeded",
            type: "success",
          });
          this.ruleForm.email = "";
        }
      } else {
        this.$message({
          message: "Please enter your e-mail address",
          type: "error",
        });
      }

      // this.$refs[formName].validate((valid) => {
      //   console.log(valid);
      //   if (valid) {
      //     alert("submit!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    Masg() {
      this.$message("Coming Soon");
    },
  },
};
</script>

<style lang="less" scoped>
.mintfoot{
  width: 100%;
  background: #291838;
}
.foot {
  width: 100%;
  background: #141414;
}
.footer-W {
  background: #141414;
}
.mintfoot-W {
  background: #291838;
}

.footer-W,.mintfoot-W {
  width: 1320px;
  margin: 0 auto;

  .footer-Top {
    p {
      a {
        color: #ffffff;
      }
    }
    p:nth-child(1) {
      width: 827px;
      font-size: 52px;
      // font-family: HarmonyOS Sans-Bold;
      //  font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
      font-family: "Microsoft YaHei";
      font-weight: bold;
      color: #ffffff;
      line-height: 73px;
    }
    p:nth-child(2) {
      margin-top: 20px;
      .el-form-item {
        display: inline-block;
        margin-bottom: 93px;
      }
      .demo-dynamic ::v-deep .el-input__inner {
        width: 480px;
        height: 50px;
        border-radius: 20px 20px 20px 20px;
        border: 2px solid #ffffff;

        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 14px;
        color: rgba(255, 255, 255, 0.6);
      
        padding: 0 30px;
        background: #000;
      }
      .el-button {
        height: 50px;
        border-radius: 20px 20px 20px 20px;
        background: #fff;
        font-size: 18px;
        // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
        // font-family: HarmonyOS Sans SC-Regular;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #141414;
        margin-left: 20px;
      }
    }
    ul {
      display: flex;
      border-bottom: 1px solid #ffffff;
      padding-bottom: 68px;
      li {
        flex: 1;
        p {
          width: 237px !important;
          font-size: 14px !important;
          // font-family: HarmonyOS Sans-Regular;
          // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
          margin: 12px 0 !important;
          cursor: pointer;
        }
        p:nth-child(1) {
          font-size: 18px !important;
          //font-family: HarmonyOS Sans-Bold;
          // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
          font-family: "Microsoft YaHei";
          font-weight: bold;
          color: #ffffff;
          line-height: 25px;
          margin-bottom: 28px !important;
        }
        .ap {
          p {
            width: 237px !important;
            font-size: 14px !important;
            // font-family: HarmonyOS Sans-Regular !important;
            // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #ffffff;
            line-height: 20px;
            margin: 12px 0 !important;
          }
        }
      }
    }
    padding-top: 156px;
  }
  .footer-BOttom {
    width: 100%;
    height: 30px;
    padding: 66px 0 147px 0;

    // p:nth-child(1) {
    //   float: left;
    //   font-size: 16px;
    //   font-family: HarmonyOS Sans-Bold;

    //   color: #ffffff;
    //   line-height: 22px;
    //   span:nth-child(1) {
    //     // display: block;
    //     padding-bottom: 2px;
    //     font-weight: bold;

    //   }
    //   span:nth-child(5) {
    //    // color: red;
    //     font-size: 12px !important;
    //     font-family: HarmonyOS Sans-Regular;
    //   }
    //   span:nth-child(3) {
    //      //color: red;
    //     //font-size: 12px !important;
    //      font-family: HarmonyOS Sans-Bold;
    //     font-size: 14px !important;
    //    // font-family: HarmonyOS Sans-Regular;
    //   }
    // }
    p:nth-child(1) {
      // float: right;
      font-size: 16px;
      //font-family: HarmonyOS Sans-Bold;
      // font-family: HarmonyOS Sans-Black, HarmonyOS Sans;
      font-family: "Microsoft YaHei";
      font-weight: bold;
      color: #ffffff;
      line-height: 22px;
      span:nth-child(1) {
        margin-right: 34px;
      }
      span:nth-child(2) {
        img {
          width: 24px;
          height: 24px;
          margin-right: 24px;
        }
        img:nth-child(5) {
          margin-right: 0px;
        }
      }
    }
    .footerby {
      display: flex;
      // border: 1px solid red;
      justify-content: space-between;
      margin-top: 30px;
      span {
        height: 22px;
        font-size: 16px;
        font-family: HarmonyOS Sans-Bold, HarmonyOS Sans;
        font-weight: 700;
        color: #ffffff;
        line-height: 22px;
      }
    }
  }
}
</style>
